(function () {
  if (typeof window === 'undefined') return;

  if (!window.PUB_SUB_EVENTS) {
    window.PUB_SUB_EVENTS = {
      cartUpdate: 'cart-update',
      cartError: 'cart-error',
      variantChange: 'variant-change',
      quantityUpdate: 'quantity-update'
    };
  }

  var subscribers = window.__PUB_SUB__ || {};
  window.__PUB_SUB__ = subscribers;

  window.subscribe = window.subscribe || function (eventName, callback) {
    if (!eventName || typeof callback !== 'function') return function () {};
    subscribers[eventName] = subscribers[eventName] || [];
    var entry = { callback: callback };
    subscribers[eventName].push(entry);
    return function () {
      var list = subscribers[eventName] || [];
      var idx = list.indexOf(entry);
      if (idx > -1) list.splice(idx, 1);
    };
  };

  window.publish = window.publish || function (eventName, payload) {
    var list = subscribers[eventName];
    if (!list || list.length === 0) return;
    list.slice().forEach(function (entry) {
      try {
        entry.callback(payload);
      } catch (err) {
        // swallow to avoid breaking all subscribers
        console.warn('[pubsub] subscriber error', err);
      }
    });
  };
})();
